import {createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromGlobal from './global.reducer';

export const selectGlobalState = createFeatureSelector<fromGlobal.GlobalState>(
  fromGlobal.globalFeatureKey
);
export const selectIsConfigLoaded = createSelector(
  selectGlobalState, s1 => s1.initialConfigLoaded);
